import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  imports: [ButtonsComponent],
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent {}
